export default class ZipcodeAutocomplete {
    constructor(component) {
        this.component = component;

        this.input = this.component.querySelector('[data-zipcodes]');
        this.list = this.component.querySelector('[data-zipcodes-list]');
        this.options = this.list.querySelectorAll('[data-zipcode-item]');
        this.noResultText = this.list.querySelector('[data-no-result]');

        this.init();

        this.currentFocus = 1;
    }

    init() {
        for (const option of this.options) {
            option.addEventListener('click', (e) => {
                this.options.forEach((option) => {
                    option.classList.remove('active');
                });

                this.input.value = option.value;
                this.list.style.display = 'none';
                option.classList.add('active');
            });
        }

        this.input.addEventListener('input', (e) => {
            const currentLength = [];

            const text = this.input.value.toUpperCase();
            this.list.style.display = 'block';

            for (const option of this.options) {
                if (option.value.toUpperCase().indexOf(text) > -1) {
                    option.style.display = 'block';
                    currentLength.push(1);
                } else {
                    option.style.display = 'none';
                }
            }

            if (currentLength.length === 0) {
                this.noResultText.classList.remove('d-none');
            } else {
                this.noResultText.classList.add('d-none');
            }
        });

        this.input.addEventListener('keydown', (e) => {
            // Down key
            if (e.keyCode === 40) {
                this.currentFocus += 1;
                this.addActive(this.options);
            } else if (e.keyCode === 38) {
                // Up key
                this.currentFocus -= 1;
                this.addActive(this.options);
            } else if (e.keyCode === 13 || e.keyCode === 32) {
                // Enter or spacebar
                e.preventDefault();
                if (this.currentFocus > -1) {
                    if (this.options) {
                        this.options[this.currentFocus].click();
                    }
                }
            }
        });
    }

    addActive(x) {
        if (!x) return false;

        this.removeActive(x);

        if (this.currentFocus >= x.length) this.currentFocus = 0;
        if (this.currentFocus < 0) this.currentFocus = x.length - 1;
        x[this.currentFocus].classList.add('active');
    }

    removeActive(x) {
        for (let i = 0; i < x.length; i++) {
            x[i].classList.remove('active');
        }
    }
}
